/**
 * The violet-bordered consent explanation shown above the engagements list
 * and above the registration door's relance block (`.consent` in
 * `docs/maquettes/prototype-terrain.html`: `--border-strong`, the one accent
 * the charter allows to single out a block).
 */
import type { ReactNode } from 'react';

export interface ConsentBoxProps {
  children: ReactNode;
}

/**
 * Render the consent explanation box.
 *
 * @param props - The explanation text.
 * @returns The consent box element.
 */
export function ConsentBox({ children }: ConsentBoxProps) {
  return <div className="consent">{children}</div>;
}
